'use client'

export default function GlobalError({
  unstable_retry,
}: {
  error: Error & { digest?: string }
  unstable_retry: () => void
}) {
  return (
    <html lang="nl">
      <body style={{
        margin: 0,
        background: '#F4F1EC',
        fontFamily: 'system-ui, sans-serif',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: '0 24px',
      }}>
        <div>
          <div style={{
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: '#C24A2A',
            marginBottom: 24,
          }}>
            Fout
          </div>
          <h1 style={{ fontSize: 36, fontWeight: 700, color: '#1A1815', marginBottom: 16, letterSpacing: '-0.02em' }}>
            Er ging iets mis
          </h1>
          <p style={{ fontSize: 17, color: '#5B574F', marginBottom: 40, lineHeight: 1.6 }}>
            Er is een onverwachte fout opgetreden. Probeer het opnieuw.
          </p>
          <button
            onClick={unstable_retry}
            style={{
              background: '#C24A2A',
              color: '#F4F1EC',
              border: 'none',
              borderRadius: 10,
              padding: '14px 28px',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
              letterSpacing: '-0.01em',
            }}
          >
            Opnieuw proberen
          </button>
        </div>
      </body>
    </html>
  )
}
